import { ActivityRepository, ActivityQuery, Activity, ActivityRepositoryError, ActivityFactory } from '@/Domain/Activities'
import { LanguageCode } from '@/Domain/Localization'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'
import { AxiosActivityData } from './AxiosActivityData'

export class AxiosActivityRepository implements ActivityRepository {
  private _apiClient: ApiClient
  private _factory: ActivityFactory<AxiosActivityData>

  constructor (apiClient: ApiClient, factory: ActivityFactory<AxiosActivityData>) {
    this._apiClient = apiClient
    this._factory = factory
  }

  async byQuery (languageCode: LanguageCode, query: ActivityQuery): Promise<Activity[]> {
    try {
      const encodedQuery = encodeURIComponent(query.value())
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/activities/' + languageCode,
        { search: encodedQuery }
      )
      const activities = response.data.data.activity.map((current: AxiosActivityData) => {
        return this._factory.makeActivity(current)
      })
      return activities
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new ActivityRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }
}
